import mcp from "./modules/mcp";

export default { mcp };
